let cacheSessionStorage = {};

export default {
  get: item => {
    if (cacheSessionStorage[item]) {
      return cacheSessionStorage[item];
    }
    const val = window.sessionStorage.getItem(item);
    if (val !== undefined && val !== 'undefined') {
      try {
        const data = JSON.parse(val);
        return data;
      } catch {
        return val;
      }
    } else {
      return '';
    }
  },
  set: (key, value) => {
    cacheSessionStorage[key] = value;
    if (typeof value === 'object') value = JSON.stringify(value);
    window.sessionStorage.setItem(key, value);
  },
  remove: item => {
    cacheSessionStorage[item] = '';
    window.sessionStorage.removeItem(item);
  },
  clear: () => {
    cacheSessionStorage = {};
    window.sessionStorage.clear();
  }
};
